"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
/**
 * Returns a function that takes any number of rxjs operators to lazily transform the input
 * collection. Runs synchronously.
 * Note that the result will always we collected in an array. Even if the result is only one value (reduce)
 */
function transducer(collection) {
    return function pipe() {
        var operators = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            operators[_i] = arguments[_i];
        }
        var result = [];
        var source = rxjs_1.from(collection);
        var collect = operators_1.scan(function (acc, res) {
            acc.push(res);
            return acc;
        }, []);
        source.pipe.apply(source, __spread(operators, [collect])).subscribe(function (res) { return (result = res); });
        return result;
    };
}
exports.transducer = transducer;
